(() => {
  const SWATCH_SELECTOR = ".swatch-view-item[swatch-url]";
  const CARD_SELECTOR = ".product--card-inner[data-product-card]";

  // swatch-url(상품)별 캐시
  const productCache = new Map(); // key: absolute product url, value: Promise<productJson>

  function getElementFromEvent(e) {
    // Text node 등으로 closest가 깨지는 경우 방지
    if (e && e.composedPath) {
      const p = e.composedPath();
      for (const n of p) if (n && n.nodeType === 1) return n;
    }
    if (e && e.target && e.target.nodeType === 1) return e.target;
    if (e && e.target && e.target.parentElement) return e.target.parentElement;
    return null;
  }

  function toAbsUrl(url) {
    try {
      return new URL(url, location.origin).toString();
    } catch (e) {
      return "";
    }
  }

  function toProductJsUrl(productUrl) {
    // /products/handle  ->  /products/handle.js
    // 쿼리/해시 제거 후 .js 부착
    const u = new URL(productUrl);
    u.search = "";
    u.hash = "";
    const path = u.pathname.replace(/\/$/, "");
    u.pathname = path.endsWith(".js") ? path : `${path}.js`;
    return u.toString();
  }

  function withWidth(url, width = 900) {
    if (!url) return "";
    try {
      const u = new URL(url, location.origin);
      // 이미 width가 있으면 유지, 없으면 추가
      if (!u.searchParams.has("width")) u.searchParams.set("width", String(width));
      return u.toString();
    } catch (e) {
      // 상대경로 대비
      if (url.includes("?")) return `${url}&width=${width}`;
      return `${url}?width=${width}`;
    }
  }

  async function fetchProductJsonByUrl(productUrlAbs) {
    if (!productUrlAbs) return null;

    if (!productCache.has(productUrlAbs)) {
      const jsUrl = toProductJsUrl(productUrlAbs);
      const p = fetch(jsUrl, { credentials: "same-origin" }).then((r) => {
        if (!r.ok) throw new Error(`Failed to fetch ${jsUrl}: ${r.status}`);
        return r.json();
      });
      productCache.set(productUrlAbs, p);
    }
    try {
      return await productCache.get(productUrlAbs);
    } catch (e) {
      return null;
    }
  }

  function pickMainAndHover(productJson) {
    if (!productJson) return { main: "", hover: "" };

    const images = Array.isArray(productJson.images) ? productJson.images : [];
    const featured = productJson.featured_image || images[0] || "";
    const main = featured || "";

    // hover 후보: Full-Body / Model / Lifestyle 등 우선
    const preferRe = /(full[-_ ]?body|fullbody|model|lifestyle|front|back)/i;
    let hover =
      images.find((u) => preferRe.test(u) && u !== main) ||
      images.find((u) => u !== main) ||
      images[1] ||
      main ||
      "";

    // main과 같으면(이미지 1개뿐) hover도 main으로
    if (!hover) hover = main;
    return { main, hover };
  }

  function findMainImg(card) {
    return (
      card.querySelector("img.product--card-main-img") ||
      card.querySelector(".product--card-main-img img") ||
      card.querySelector(".product--card-image img")
    );
  }

  function findHoverImg(card) {
    return (
      card.querySelector("img.product-second-img") ||
      card.querySelector(".product-second-img img")
    );
  }

  function ensureHoverImg(card) {
    let hoverImg = findHoverImg(card);
    if (hoverImg) return hoverImg;

    const mainImg = findMainImg(card);
    if (!mainImg) return null;

    // main 이미지를 복제해서 hover 이미지로 추가
    const clone = mainImg.cloneNode(true);
    clone.classList.remove("product--card-main-img");
    clone.classList.add("product-second-img");

    // lazyload 잔여 속성 정리
    clone.removeAttribute("srcset");
    clone.removeAttribute("data-srcset");

    // main 다음에 삽입
    mainImg.insertAdjacentElement("afterend", clone);
    return clone;
  }

  function setImage(img, url) {
    if (!img || !url) return;

    const finalUrl = withWidth(url, 900);

    // srcset이 남아있으면 브라우저가 다른 리소스를 선택할 수 있어 제거
    img.removeAttribute("srcset");
    img.removeAttribute("data-srcset");

    // lazy 이미지 호환
    img.setAttribute("src", finalUrl);
    img.setAttribute("data-src", finalUrl);

    // 테마에서 data-original을 쓰는 케이스 방지
    img.setAttribute("data-original", finalUrl);
  }

  async function syncCardBySwatchUrl(card, productUrlAbs) {
    const data = await fetchProductJsonByUrl(productUrlAbs);
    if (!data) return;

    const { main, hover } = pickMainAndHover(data);

    // 스와치 플러그인이 이미 main을 바꾸는 경우가 많아도,
    // 여기서 다시 세팅해도 안전(동일 URL로 덮어쓰기)
    const mainImg = findMainImg(card);
    if (mainImg && main) setImage(mainImg, main);

    const hoverImg = ensureHoverImg(card);
    if (hoverImg && hover) setImage(hoverImg, hover);

    // 카드 dataset도 동기화(디버깅/추가 로직 대비)
    if (main) card.dataset.selectedMainImage = withWidth(main, 900);
    if (hover) card.dataset.selectedHoverImage = withWidth(hover, 900);
  }

  function handleEvent(e) {
    const el = getElementFromEvent(e);
    if (!el || !el.closest) return;

    const swatch = el.closest(SWATCH_SELECTOR);
    if (!swatch) return;

    const card = swatch.closest(CARD_SELECTOR);
    if (!card) return;

    const swatchUrl = swatch.getAttribute("swatch-url") || "";
    const abs = toAbsUrl(swatchUrl);
    if (!abs) return;

    // 스와치 플러그인이 DOM 업데이트를 한 뒤에 맞춰서 동기화
    setTimeout(() => syncCardBySwatchUrl(card, abs), 0);
  }

  // click + hover(마우스오버) 모두 대응
  document.addEventListener("click", handleEvent, true);
  document.addEventListener("mouseover", handleEvent, true);
})();
